import { IResponseProcessor } from "..";

/** @deprecated This will be removed. For new development, use the `useGetV4WarehousesQuery` hook from 'randmar-api-client' instead. */
class WarehousesApi {
  constructor(
    private _baseUrl: string,
    private _getToken: () => string,
    private _processor: IResponseProcessor
  ) {
    console.warn(
      "Deprecation Warning: The legacy 'WarehousesApi' class is in use. Please migrate to RTK Query hooks from 'randmar-api-client'. Prefer using 'useGetV4WarehousesQuery'."
    );
  }

  async getWarehouses(): Promise<IWarehouse[]> {
    const res = await fetch(`${this._baseUrl}/Warehouses`, { headers: { Authorization: `Bearer ${this._getToken()}` }, });

    this._processor.process(res);

    if (!res.ok) {
      throw new Error(`Failed to fetch warehouses: ${res.status} ${res.statusText}`);
    }

    const data: IWarehouse[] = await res.json();

    return data;
  }
}

/** @deprecated This will be removed. Use the Warehouse type from randmar-api-client instead. */
export interface IWarehouse {
  readonly Address1: string,
  readonly Address2: string,
  readonly ApplicationId: string,
  readonly City: string,
  readonly ContactEmail: string,
  readonly ContactName: string,
  readonly ContactPhone: string,
  readonly Country: string,
  readonly IntegrationKeyName: string,
  readonly MaxInventoryCubicMeter: number,
  readonly MaxInventoryValue: number,
  readonly Name: string,
  readonly PostalCode: string,
  readonly Province: string,
  readonly WarehouseId: string,
  readonly WarehouseType: string
}

export default WarehousesApi;
